
















































































import Vue from 'vue';
import HHeroll from '@/ui/components/base/HHeroll.vue';
import HIcon from '@/ui/components/base/HIcon.vue';
import serviceProvider from '@/services/service-provider';

export default Vue.extend({
  name: 'LadingPage',
  components: {
    HHeroll,
    HIcon,
  },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
  methods: {
    changeLang(lang: string) {
      serviceProvider.i18n.changeLocale(lang);
      window.location.reload();
    },
  },
});
